<template>
    <div>
        <div class="row game__match mb--sm" v-for="match in matches">
            <div class="col-6" v-for="(matchUser, index) in match.quizUsers">
                <div :class="['player', {'player--loss': matchUser.won === 0, 'player--win': matchUser.won === 1}]">
                    <div class="profile profile--inline profile--horizontal">
                        <figure class="profile__avatar"><span
                            class="profile__avatar__img"><img
                            :src="matchUser.user.avatar" alt=""></span></figure>
                        <div class="score">{{ matchUser.point }}</div>
                        <div class="profile__text weight--bold">{{ matchUser.nick }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['matches']
    }
</script>
